import type { ReviveBoostRequest } from "@newfungame/contracts";

export interface ReviveBoostActions {
  /** Выбор подкрепления после реванша (`app/payments.ts`); обещание завершается с ответом сервера. */
  reviveBoost(pick: ReviveBoostRequest): void | Promise<void>;
}

const noop = () => {};

export const defaults: ReviveBoostActions = {
  reviveBoost: noop,
};

declare module "../actions" {
  interface WindowActions extends ReviveBoostActions {}
}
